export const subscribeModeMapping = {
  1: '月',
  2: '季',
  3: '月',
  4: '季',
  5: '半年',
  6: '年'
};

export const shopSource = {
  'dev.shusheng.JoJoRead': 'JOJO_APP', // 叫叫APP
  'com.shusheng.JoJoRead': 'JOJO_APP', // 叫叫APP
  'com.jojoread.JoJoSherlock': 'CHINESE_ADVENTURE', // 新识字/汉字大冒险
  'com.tinmanarts.JoJoSherlock': 'LITERACY_APP', // 老识字
  'com.jojoread.huiben': 'PICTURE_APP', // 绘本
  'com.jojoread.JoJoCalculate': 'ORAL_CALCULATION_APP', // 口算
  wx8734de71e9438268: 'POLARIS_MINI', // 北极星小程序
  wx53aed20bd888a9a7: 'POLARIS_MINI', // 北极星测试环境小程序,趣读西游
  wxed0b8a672924899a: 'GROWTH_CENTER_MINI', // 成长中心小程序
  wx1fbbaa6654693d53: 'CHILDREN_READ_MINI' // 叫叫儿童阅读小程序
};

// 来源code
export const shopSourceCode = {
  JOJO_APP: '', // 叫叫APP
  CHINESE_ADVENTURE: 305, // 新识字/汉字大冒险
  LITERACY_APP: 305, // 老识字
  PICTURE_APP: 304, // 绘本
  ORAL_CALCULATION_APP: 307, // 口算
  POLARIS_MINI: 310, // 北极星小程序
  GROWTH_CENTER_MINI: '', // 成长中心小程序
  CHILDREN_READ_MINI: '' // 叫叫儿童阅读小程序
};

export const certificateTypeMapping = {
  IDENTITY_CARD: '台湾本地身份证',
  PASSPORT: '护照',
  RESIDENT_PERMIT: '台湾本地居留证'
};

export const platformList = {
  1: '微信内',
  2: '微信小程序',
  3: 'APP内'
};

export const platformLimitTypes = {
  1: 'H5',
  2: 'APPLETS',
  3: 'APP'
};
